import { httpGet, httpPost, httpPut, httpDelete } from "../utils/http";
import { CryptoKey } from "../utils/emunData";
import Crypto from "../utils/crypto";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  lastDeviceExamList(
    dateBegin,
    dateEnd,
    examArchived,
    keywordType,
    keyword,
    currentPage
  ) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/exam/lastDeviceList?dateBegin=${dateBegin}&dateEnd=${dateEnd}&examArchived=${examArchived}&keyword=${keyword}&keywordType=${keywordType}&currentPage=${currentPage}`;
    return httpGet(apiUrl);
  }

  getAllList(petID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/exam/allList?petID=${petID}`;
    return httpPost(apiUrl);
  }

  loadRecordAttachCandidate(condition) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/exam/attach/candidate/record`;
    return httpPost(apiUrl, condition);
  }

  loadInHospitalAttachCandidate(condition) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/exam/attach/candidate/inHospital`;
    return httpPost(apiUrl, condition);
  }

  examAttach(petID, docID, examIDs, optUserID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/exam/attach?optUserID=${optUserID}`;
    return httpPost(apiUrl, { petID, docID, examIDs });
  }

  deleteExams(examIDs, optUserID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/exam?optUserID=${optUserID}`;
    return httpDelete(apiUrl, examIDs);
  }
  getExamDeviceByAttachedID(attachedID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/exam/device/attachedID?attachedID=${attachedID}`;
    return httpGet(apiUrl);
  }
  getExamDeviceByPetID(petID, attachType, clinic) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinicID}/exam/device/petID?petID=${petID}&attachType=${attachType}`;
    return httpGet(apiUrl);
  }
  updateExamDeviceResults(examDeviceResults, optUserID) {
    //key:examDeviceID,value:nested object with exam key and record value
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/exam/device/bluk/result?optUserID=${optUserID}`;
    return httpPut(apiUrl, examDeviceResults);
  }

  getExamCountByDate(dateBegin, dateEnd) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/exam/count?dateBegin=${dateBegin}&dateEnd=${dateEnd}`;
    return httpGet(apiUrl);
  }

  getExamReportUrl(recordID, type) {
    return `${this.apiEndpoint}/api/${localStorage.getItem(
      "CLINIC"
    )}/examPdf/${Crypto.encrypt(recordID, CryptoKey)}/${type}`;
  }
}
